import Dropdown from './Components/Dropdown'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  const dropdown = new Dropdown()
  dropdown.init()
})
